import { render, staticRenderFns } from "./OctGlobalnav.vue?vue&type=template&id=39c6eb92&scoped=true&"
import script from "./OctGlobalnav.vue?vue&type=script&lang=js&"
export * from "./OctGlobalnav.vue?vue&type=script&lang=js&"
import style0 from "./OctGlobalnav.vue?vue&type=style&index=0&id=39c6eb92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c6eb92",
  null
  
)

export default component.exports